module.exports = __webpack_public_path__ + "img/b2-1.2bcf2b6.png";